import { render } from "./PosterGroupRenderer.vue?vue&type=template&id=58f91009"
import script from "./PosterGroupRenderer.vue?vue&type=script&lang=js"
export * from "./PosterGroupRenderer.vue?vue&type=script&lang=js"

import "./PosterGroupRenderer.vue?vue&type=style&index=0&id=58f91009&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__